import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  strapiDeleteMyUserSigned,
  strapiFetchMyUserSigned,
  strapiSaveMyUserSigned,
} from '../../api/strapiUserSigned';
import { queryKeys } from '../queryKeys';

export function useMyUserSignedQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.myUserSigned(jwt),
    queryFn: () => strapiFetchMyUserSigned(jwt!),
    enabled: Boolean(jwt),
  });
}

export function useSaveMyUserSignedMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sign: string) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiSaveMyUserSigned(jwt, sign);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.myUserSigned(jwt) });
    },
  });
}

export function useDeleteMyUserSignedMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => {
      if (!jwt) throw new Error('Not signed in');
      return strapiDeleteMyUserSigned(jwt);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.myUserSigned(jwt) });
    },
  });
}
